import { getCurrentInstance } from 'vue';

export function useFiltroMultiSelect({ filtro, path, transformValor = null }) {
  const { proxy } = getCurrentInstance();

  function onAtualizar(selecionados) {
    const valor = transformValor ? transformValor(selecionados) : selecionados;
    proxy.$aplicaFiltroEmURL(filtro.value.filtro, valor, path.value);
    proxy.$store.commit('addFiltro', filtro.value);
    proxy.$store.commit('addFiltroAplicado', {
      filtro: filtro.value.filtro,
      valor,
    });
  }

  return { onAtualizar };
}
